/**
 * Built-in effect `pixel` (W2-01b; P§5.2): pixelation into square blocks of `size` render-target pixels, each
 * showing the colour at its centre. Blocks are aligned to the bottom-left of the target. Reimplemented from the
 * behaviour (badged approximate).
 */

import { m } from './builtinFx.messages';
import { defineBuiltin, SAMPLE_SCREEN } from './shared';

export const pixel = defineBuiltin({
  name: 'pixel',
  label: { key: m.pixel },
  description: { key: m.pixelDesc },
  inputs: ['screenSize'],
  uniforms: [{ name: 'size', type: 'float', default: 10, min: 1, max: 128, label: { key: m.pixelSize } }],
  helpers: [SAMPLE_SCREEN],
  main: `
void main() {
  vec2 cell = vec2(max(size, 1.0)) / max(screenSize, vec2(1.0));
  gl_FragColor = sampleScreen((floor(uv / cell) + 0.5) * cell);
}`,
});
